import { useContext, useState, useEffect } from 'react';

import IndexRate from '@lcsc-ui/components/IndexRate';
import { SearchBar, MenuBar } from '@lcsc-ui/layouts/baseHeader';
import IndexDialogManage from '@lcsc-ui/layouts/baseHeader/components/AdDialogManage';
import { CatalogsPopIndex } from '@lcsc-ui/layouts/baseHeader/components/popBus.js';
import { getCartDataApi } from '@lcsc-ui/layouts/baseHeader/header-http';
import useUserStore from '@lcsc-ui/store/user';
import indexBuriedPoint from '@lcsc-ui/utils/_indexBuriedPoint';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';
import Cookies from 'js-cookie';
import { debounce } from 'lodash-es';
import dynamic from 'next/dynamic';

import IndexActivityAd from './IndexActivityAd';
import IndexBannerArea from './IndexBannerArea';
import IndexBrandAd from './IndexBrandAd';
import IndexInformationArea from './IndexInformationArea';
import IndexLoinAd from './IndexLoinAd';
import IndexMainRight from './IndexMainRight';

import BottomAdContext from '@/context/BottomAdContext';

const DynamicIndexTopBannerComponent = dynamic(() => import('@lcsc-ui/layouts/baseHeader/components/IndexTopBanner'));
const DynamicIndexBottomFloatAdComponent = dynamic(
  () => import('@lcsc-ui/layouts/baseHeader/components/BottomFloatAd')
);

const FloatHeader = ({ isLg, logined, headerAd, searchKeyWord, changeSearchKeyWord }) => {
  const [isFloat, setIsFloat] = useState(false);
  const debounceScroll = debounce(scrollFn, 40);

  useEffect(() => {
    document.addEventListener('scroll', debounceScroll);
    return () => {
      document.removeEventListener('scroll', debounceScroll);
    };
  }, []);

  function scrollFn() {
    let scrollTop = 0;
    if (document?.documentElement?.scrollTop) {
      scrollTop = document.documentElement.scrollTop;
    } else if (document?.body?.scrollTop) {
      scrollTop = document.body.scrollTop;
    }
    if (scrollTop > 100) {
      setIsFloat(true);
    } else {
      setIsFloat(false);
    }
  }

  return (
    <header
      className={`w-full fixed z-[200] transition-all duration-300 ${isFloat ? 'top-[0] h-[72px]' : 'top-[-99px] h-[97px]'}`}
      id="float-header"
    >
      {isFloat && (
        <SearchBar
          logined={logined}
          isLg={isLg}
          headerAd={headerAd}
          className={`transition-all duration-500 ${isFloat ? 'h-[0] overflow-hidden' : ''}`}
          isFloat={isFloat}
          searchKeyWord={searchKeyWord}
          showH1Title={true}
          changeSearchKeyWord={changeSearchKeyWord}
        />
      )}
    </header>
  );
};

const IndexContent = ({ IndexData, indexAd, headerAd, resourceData }) => {
  const { isLgScreen } = useContext(BottomAdContext);
  const { updateUserInfo } = useUserStore();
  const [logined, setLogined] = useState(false);
  const [isBanners, setFaterBannerResult] = useState(false);
  const [searchKeyWord, setSearchKeyWord] = useState('');

  useEffect(() => {
    if (indexAd?.skinColour) {
      // 换肤
      document.documentElement.classList.add('grey');
    }
    Utils.reloadLoginFrame()
      .then((result) => {
        Utils.setInfoSecurityLocalStorage(result);
        autoRefreshLoginInfo(result);
      })
      .catch(() => {
        console.log('登录重试中...');
        Utils.casLogin();
        getCartData();
      });
  }, []);

  async function getCartData() {
    // 获取购物车
    const cartRes = await getCartDataApi();
    let cartNum = 0;
    if (cartRes.code !== 200 || !cartRes.result.shoppingCartVO.cartTotalSize) {
      cartNum = 0;
    } else {
      cartNum = cartRes.result?.shoppingCartVO?.cartTotalSize; // 购物车数量
    }
    updateUserInfo({
      complaintName: '',
      complaintPhone: '',
      couponNum: null, // 优惠券数量
      customerCode: '', // 客户编码
      customerLogin: 0, // 是否登录
      customerStarLevel: null, // plus会员
      encryptSwitch: '',
      messageNum: null,
      privateKey: '',
      publicKey: '',
      saleQQ: null,
      salesmanCode: '',
      salesmanName: '',
      salesmanPhone: '',
      cartNum, // 购物车数量
    });
  }

  // 自动刷新登录状态
  function autoRefreshLoginInfo(data) {
    updateUserInfo(data);
    setLogined(true);

    const { customerCode } = data;
    // 用户行为分析埋点
    if (Cookies.get('isLoginCustomerFlag') !== customerCode) {
      Cookies.set('isLoginCustomerFlag', customerCode, {
        domain: '.szlcsc.com',
        path: '/',
      });

      buriedPoint({ ty: 'login', data: Cookies.get('noLoginCustomerFlag') });

      Cookies.set('noLoginCustomerFlag', '', {
        domain: '.szlcsc.com',
        path: '/',
      });
    }
  }

  const changeSearchKeyWord = (value) => {
    setSearchKeyWord(value);
  };

  return (
    <section className={`pb-[60px] bg-[#F6F8FA]`}>
      {/* 广告位 */}
      <DynamicIndexTopBannerComponent logined={logined} needMb setFaterBannerResult={setFaterBannerResult} />
      <FloatHeader
        headerAd={headerAd}
        logined={logined}
        isLg={isLgScreen}
        searchKeyWord={searchKeyWord}
        changeSearchKeyWord={changeSearchKeyWord}
      />
      <section
        className={`${isBanners ? 'mt-[0px]' : 'mt-[20px]'} mx-auto w-[1200px] _lg:w-[1552px] bg-white rounded-[20px] relative z-[10] box-border`}
      >
        <SearchBar
          notIndexHeaderAdapter={false}
          logined={logined}
          isLg={isLgScreen}
          headerAd={headerAd}
          wrapClassName="rounded-t-[20px]"
          searchKeyWord={searchKeyWord}
          changeSearchKeyWord={changeSearchKeyWord}
          showH1Title={true}
        ></SearchBar>
        <MenuBar isLg={isLgScreen} isIndex headerAd={headerAd}></MenuBar>
        <section className="mt-[20px] flex px-[20px] pb-[20px]">
          <section className="w-[242px] h-[521px] bg-[#f5f5f5] rounded-[10px] mr-[16px]">
            <CatalogsPopIndex resourceData={resourceData}></CatalogsPopIndex>
          </section>
          <section className="w-[634px] _lg:w-[996px] h-full">
            <IndexBannerArea logined={logined} />
          </section>
          <section className="ml-[18px]">
            <IndexMainRight logined={logined} data={IndexData}></IndexMainRight>
          </section>
        </section>
      </section>
      {/* 找料、推料、爆款等tab页面 */}
      <IndexActivityAd isLg={isLgScreen} data={indexAd}></IndexActivityAd>
      {/* 腰部轮播广告 */}
      <IndexLoinAd data={indexAd}></IndexLoinAd>
      {/* 品牌广告 */}
      <IndexBrandAd isLgScreen={isLgScreen} data={indexAd}></IndexBrandAd>
      {/* 四大资讯区域 */}
      <IndexInformationArea isLgScreen={isLgScreen} data={IndexData}></IndexInformationArea>
      {/* EasyEDA */}
      {/* 底部广告 */}
      {indexAd?.bottomAd && (
        <a
          aria-label="立创商城-首页-嘉立创EDA"
          className="mt-[20px] w-[1200px] _lg:w-[1552px] h-[100px] block mx-auto"
          href={indexAd?.bottomAd?.targetLink}
          target="_blank"
          title={indexAd?.bottomAd?.title}
          onClick={() => indexBuriedPoint('Bottom_advertisement', indexAd.bottomAd?.targetLink)}
          data-spm="bad"
        >
          <img
            className="rounded-[20px] w-full h-full object-cover"
            src={indexAd?.bottomAd?.advertisingUrl}
            alt={indexAd?.bottomAd?.title}
          />
        </a>
      )}
      {/* 底部悬浮广告 */}
      <DynamicIndexBottomFloatAdComponent headerAd={headerAd} />
      <IndexDialogManage grey={indexAd?.skinColour} />
      <IndexRate requestPage="home" />
    </section>
  );
};

export default IndexContent;
